export default __webpack_public_path__ + "static/media/trackerImage.3f1a880f.webp";